import findFavoritesStore from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Set the find favorites text
 * @param text The search text to set
 */
export default mutatorAction('setFindText', function setFindText(text) {
    findFavoritesStore.findText = text;
});
//# sourceMappingURL=setFindText.js.map